module.exports = __webpack_public_path__ + "static/media/slide-3.ccfa5735.jpg";